import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { MatDialog, MatSnackBar } from '@angular/material';
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { Observable } from 'rxjs';
import { LearnerService } from '../../services/learner.service';
@Component({
  selector: 'app-rail-layout2-feedback',
  templateUrl: './rail-layout2-feedback.component.html',
  styleUrls: ['./rail-layout2-feedback.component.scss']
})
export class RailLayout2FeedbackComponent implements OnInit {


  @Input('learner') learnerObj;
  @Input('jobId') job;
  @Input('assessment') editAssesment
  feedbackForm
  currentJob
  learnerData
  learnerName
  assesmentEdit
  sign = false
  sign1 = false
  sign2 = false
  sign3 = false
  sign4 = false
  sign5 = false
  sign6 = false
  sign7 = false
  sign8 = false
  sign9 = false
  sign10 = false
  sign11 = false
  sign12 = false
  sign13 = false
  sign14 = false
  sign15 = false
  sign16 = false
  sign17 = false
  sign18 = false
  sign19 = false
  sign20 = false
  sign21 = false
  sign22 = false
  sign23 = false
  sign24 = false
  sign25 = false
  isEdit: boolean = false
  constructor(

    public formBuilder: FormBuilder,
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService,

  ) { }

  ngOnInit() {
    if(!this.isEdit)
      this.createForm()
  }



  ngOnChanges(changes: SimpleChanges) {
    console.log("there are changes in assesment plan", changes)
    if (changes.job && changes.job.currentValue) {
      this.currentJob = changes.job.currentValue
    }

    if (changes.learnerObj && changes.learnerObj.currentValue) {
      this.learnerData = changes.learnerObj.currentValue
      this.learnerName = this.learnerData.name
      // this.createForm()
    }

    if (changes.editAssesment && changes.editAssesment.currentValue && changes.editAssesment.currentValue.feedbackForm) {
      this.assesmentEdit = changes.editAssesment.currentValue.feedbackForm
      let size = Object.keys(this.assesmentEdit).length;
      if (size != 0) {
        console.log("this is for edit");

        if (this.assesmentEdit && this.assesmentEdit.sign != "") {
          this.sign = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign1 != "") {
          this.sign1 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign2 != "") {
          this.sign2 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign3 != "") {
          this.sign3 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign4 != "") {
          this.sign4 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign5 != "") {
          this.sign5 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign6 != "") {
          this.sign6 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign7 != "") {
          this.sign7 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign8 != "") {
          this.sign8 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign9 != "") {
          this.sign9 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign10 != "") {
          this.sign10 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign11 != "") {
          this.sign11 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign12 != "") {
          this.sign12 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign13 != "") {
          this.sign13 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign14 != "") {
          this.sign14 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign15 != "") {
          this.sign15 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign16 != "") {
          this.sign16 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign17 != "") {
          this.sign17 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign18 != "") {
          this.sign18 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign19 != "") {
          this.sign19 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign20 != "") {
          this.sign20 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign21 != "") {
          this.sign21 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign22 != "") {
          this.sign22 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign23 != "") {
          this.sign23 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign24 != "") {
          this.sign24 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.sign25 != "") {
          this.sign25 = true
        }
        this.isEdit = true
        this.createForm(this.assesmentEdit)

      } else {
        this.isEdit = false
        this.createForm()
      }
      // console.log('changes.editAssesment.currentValue', changes.editAssesment.currentValue)
    }
  }



  // FORM CONTROLL

  createForm(details?) {
    console.log("details while edit", details);

    this.feedbackForm = new FormGroup({
      sign: new FormControl((details && details.sign) ? details.sign : ''),
      sign1: new FormControl((details && details.sign1) ? details.sign1 : ''),
      sign2: new FormControl((details && details.sign2) ? details.sign2 : ''),
      sign3: new FormControl((details && details.sign3) ? details.sign3 : ''),
      sign4: new FormControl((details && details.sign4) ? details.sign4 : ''),
      sign5: new FormControl((details && details.sign5) ? details.sign5 : ''),
      sign6: new FormControl((details && details.sign6) ? details.sign6 : ''),
      sign7: new FormControl((details && details.sign7) ? details.sign7 : ''),
      sign8: new FormControl((details && details.sign8) ? details.sign8 : ''),
      sign9: new FormControl((details && details.sign9) ? details.sign9 : ''),
      sign10: new FormControl((details && details.sign10) ? details.sign10 : ''),
      sign11: new FormControl((details && details.sign11) ? details.sign11 : ''),
      sign12: new FormControl((details && details.sign12) ? details.sign12 : ''),
      sign13: new FormControl((details && details.sign13) ? details.sign13 : ''),
      sign14: new FormControl((details && details.sign14) ? details.sign14 : ''),
      sign15: new FormControl((details && details.sign15) ? details.sign15 : ''),
      sign16: new FormControl((details && details.sign16) ? details.sign16 : ''),
      sign17: new FormControl((details && details.sign17) ? details.sign17 : ''),
      sign18: new FormControl((details && details.sign18) ? details.sign18 : ''),
      sign19: new FormControl((details && details.sign19) ? details.sign19 : ''),
      sign20: new FormControl((details && details.sign20) ? details.sign20 : ''),
      sign21: new FormControl((details && details.sign21) ? details.sign21 : ''),
      sign22: new FormControl((details && details.sign22) ? details.sign22 : ''),
      sign23: new FormControl((details && details.sign23) ? details.sign23 : ''),
      sign24: new FormControl((details && details.sign24) ? details.sign24 : ''),
      sign25: new FormControl((details && details.sign25) ? details.sign25 : ''),
      date: new FormControl((details && details.date) ? details.date : ''),
      date1: new FormControl((details && details.date1) ? details.date1 : ''),
      date2: new FormControl((details && details.date2) ? details.date2 : ''),
      date3: new FormControl((details && details.date3) ? details.date3 : ''),
      date4: new FormControl((details && details.date4) ? details.date4 : ''),
      date5: new FormControl((details && details.date5) ? details.date5 : ''),
      date6: new FormControl((details && details.date6) ? details.date6 : ''),
      date7: new FormControl((details && details.date7) ? details.date7 : ''),
      date8: new FormControl((details && details.date8) ? details.date8 : ''),
      date9: new FormControl((details && details.date9) ? details.date9 : ''),
      date10: new FormControl((details && details.date10) ? details.date10 : ''),
      date11: new FormControl((details && details.date11) ? details.date11 : ''),
      date12: new FormControl((details && details.date12) ? details.date12 : ''),
      date13: new FormControl((details && details.date13) ? details.date13 : ''),
      date14: new FormControl((details && details.date14) ? details.date14 : ''),
      date15: new FormControl((details && details.date15) ? details.date15 : ''),
      date16: new FormControl((details && details.date16) ? details.date16 : ''),
      input: new FormControl((details && details.input) ? details.input : ''),
      input1: new FormControl((details && details.input1) ? details.input1 : ''),
      input2: new FormControl((details && details.input2) ? details.input2 : ''),
      input3: new FormControl((details && details.input3) ? details.input3 : ''),
      input4: new FormControl((details && details.input4) ? details.input4 : ''),
      input5: new FormControl((details && details.input5) ? details.input5 : ''),
      input6: new FormControl((details && details.input6) ? details.input6 : ''),
      input7: new FormControl((details && details.input7) ? details.input7 : ''),
      input8: new FormControl((details && details.input8) ? details.input8 : ''),
      input9: new FormControl((details && details.input9) ? details.input9 : ''),
      input10: new FormControl((details && details.input10) ? details.input10 : ''),
      input11: new FormControl((details && details.input11) ? details.input11 : ''),
      input12: new FormControl((details && details.input12) ? details.input12 : ''),
    })
  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'feedbackForm')
      this.feedbackForm.get(formControl).setValue(value);
  }



  // UTILITY



  addSignature(control) {
    this.openDialog(SignaturePadComponent).subscribe((data) => {
      if (data == undefined) return

      let sign = data
      if (control == 'sign') {
        this.sign = true
        this.feedbackForm.patchValue({
          sign: sign
        })
      }
      if (control == 'sign1') {
        this.sign1 = true
        this.feedbackForm.patchValue({
          sign1: sign
        })
      }
      if (control == 'sign2') {
        this.sign2 = true
        this.feedbackForm.patchValue({
          sign2: sign
        })
      }
      if (control == 'sign3') {
        this.sign3 = true
        this.feedbackForm.patchValue({
          sign3: sign
        })
      }
      if (control == 'sign4') {
        this.sign4 = true
        this.feedbackForm.patchValue({
          sign4: sign
        })
      }
      if (control == 'sign5') {
        this.sign5 = true
        this.feedbackForm.patchValue({
          sign5: sign
        })
      }
      if (control == 'sign6') {
        this.sign6 = true
        this.feedbackForm.patchValue({
          sign6: sign
        })
      }
      if (control == 'sign7') {
        this.sign7 = true
        this.feedbackForm.patchValue({
          sign7: sign
        })
      }
      if (control == 'sign8') {
        this.sign8 = true
        this.feedbackForm.patchValue({
          sign8: sign
        })
      }
      if (control == 'sign9') {
        this.sign9 = true
        this.feedbackForm.patchValue({
          sign9: sign
        })
      }
      if (control == 'sign10') {
        this.sign10 = true
        this.feedbackForm.patchValue({
          sign10: sign
        })
      }
      if (control == 'sign11') {
        this.sign11 = true
        this.feedbackForm.patchValue({
          sign11: sign
        })
      }
      if (control == 'sign12') {
        this.sign12 = true
        this.feedbackForm.patchValue({
          sign12: sign
        })
      }
      if (control == 'sign13') {
        this.sign13 = true
        this.feedbackForm.patchValue({
          sign13: sign
        })
      }
      if (control == 'sign14') {
        this.sign14 = true
        this.feedbackForm.patchValue({
          sign14: sign
        })
      }
      if (control == 'sign15') {
        this.sign15 = true
        this.feedbackForm.patchValue({
          sign15: sign
        })
      }
      if (control == 'sign16') {
        this.sign16 = true
        this.feedbackForm.patchValue({
          sign16: sign
        })
      }
      if (control == 'sign17') {
        this.sign17 = true
        this.feedbackForm.patchValue({
          sign17: sign
        })
      }
      if (control == 'sign18') {
        this.sign18 = true
        this.feedbackForm.patchValue({
          sign18: sign
        })
      }
      if (control == 'sign19') {
        this.sign19 = true
        this.feedbackForm.patchValue({
          sign19: sign
        })
      }
      if (control == 'sign20') {
        this.sign20 = true
        this.feedbackForm.patchValue({
          sign20: sign
        })
      }
      if (control == 'sign21') {
        this.sign21 = true
        this.feedbackForm.patchValue({
          sign21: sign
        })
      }
      if (control == 'sign22') {
        this.sign22 = true
        this.feedbackForm.patchValue({
          sign22: sign
        })
      }
      if (control == 'sign23') {
        this.sign23 = true
        this.feedbackForm.patchValue({
          sign23: sign
        })
      }
      if (control == 'sign24') {
        this.sign24 = true
        this.feedbackForm.patchValue({
          sign24: sign
        })
      }
      if (control == 'sign25') {
        this.sign25 = true
        this.feedbackForm.patchValue({
          sign25: sign
        })
      }


    })
  }



  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }


  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }




  // API CALL


  submitForm() {
    // this.loading = true
    let data = {
      learnerId: this.learnerData._id,
      jobId: this.currentJob,
      version: true,
      details: {
        feedbackForm: this.feedbackForm.value
      }
    }

    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      // this.loading = false
    }, (err) => {
      // this.loading = false
      console.log("policy not accepted", err)
      this.handleSnackBar({ msg: "Something went wrong", button: "Ok" });
    })
  }



}
